import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './item-primary.module.scss';
import Link from 'next/link';

export type ItemPrimaryType = {
  className?: string;
  about?: string;
  chevron1: string;
  href?: string;
  onClick?: () => void;

  /** Variant props */
  chevron?: 'On' | 'Off';
  state?: string;
};

const ItemPrimary: NextPage<ItemPrimaryType> = ({
  className = '',
  chevron = 'On',
  state = 'Default',
  about,
  chevron1,
  onClick,
  href = '/',
}) => {
  return (
    <Link
      href={href}
      className={[styles.root, className].join(' ')}
      data-chevron={chevron}
      data-state={state}
      onClick={onClick}
    >
      <div className={styles.about}>{about}</div>
      <Image
        className={styles.chevronIcon}
        loading="lazy"
        width={24}
        height={24}
        sizes="100vw"
        alt=""
        src={chevron1}
      />
    </Link>
  );
};

export default ItemPrimary;
